var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconTextractLookupMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6793 12.3764V6.89943C17.6793 6.64218 17.5801 6.39483 17.4025 6.20879L12.7236 1.30935C12.5349 1.11177 12.2736 1 12.0004 1H2C1.44772 1 1 1.44771 1 2V21.9918C1 22.544 1.44772 22.9918 2 22.9918H5.33965M11.7031 1V7.2539H17.6797M18.3242 22.9961L15.3242 19.9961M5.32422 15.4961C5.32422 16.9548 5.90366 18.3537 6.93514 19.3852C7.96663 20.4167 9.36552 20.9961 10.8242 20.9961C12.2829 20.9961 13.6818 20.4167 14.7133 19.3852C15.7448 18.3537 16.3242 16.9548 16.3242 15.4961C16.3242 14.0374 15.7448 12.6385 14.7133 11.607C13.6818 10.5755 12.2829 9.99609 10.8242 9.99609C9.36552 9.99609 7.96663 10.5755 6.93514 11.607C5.90366 12.6385 5.32422 14.0374 5.32422 15.4961Z",
    stroke: "#1D1D1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconTextractLookupMaster);
export default __webpack_public_path__ + "static/media/streamline-icon-textract-lookup-master.a13f8958.svg";
export { ForwardRef as ReactComponent };